import { update } from 'state/util';

export const STATUS = {
  // no state
  NONE:      0,
  // pending states
  LOADING:   10,
  SAVING:    11,
  DELETING:  12,
  PENDING:   13,
  // completed states
  FAILED:    20,
  COMPLETE:  21,
  NOT_FOUND: 22,
};

const initialState = {
  status: STATUS.NONE,
  messages: []
};

// TODO: keep track of pending requests and make sure all
// are completed before releasing to normal state
export const requestStatusReducer = (state, action) => {
  if (state === undefined) {
    return initialState;
  }

  if (action.type === "LOGOUT_REQUESTED") {
    return initialState;
  }

  else if (action.type === "CLEAR_MESSAGES") {
    return initialState;
  }

  else if (action.type.match(/.*_REQUESTED/)) {
    return update(state, {
      status: STATUS.LOADING
    });
  }

  else if (action.type.match(/.*_SUCCESSFUL/)) {
    return update(state, {
      status: STATUS.COMPLETE
    });
  }

  // take the action message, extract its action source and render a
  // user-friendly error message & set error status
  else if (action.type.match(/.*_FAILED/)) {
    const messages = state.messages;
    const err = action.payload.message;
    const discriptor = action.type.match(/(.*)_FAILED/)[1]
      .replace(/_/g, " ")
      .replace(/\w\S*/g, (txt) => {
        // upper cases the first char of each word
        return `${txt.charAt(0).toUpperCase()}${txt.substr(1).toLowerCase()}`
      })
    const fullErrMsg = `${discriptor}: ${err}`;
    return update(state, {
      status: STATUS.FAILED,
      messages: messages.concat([fullErrMsg])
    });
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/state/requestStatus/reducer.js